import { render } from "./EmojiPicker.vue?vue&type=template&id=8d1bee8e&ts=true"
import script from "./EmojiPicker.ts?vue&type=script&lang=ts&external"
export * from "./EmojiPicker.ts?vue&type=script&lang=ts&external"

import "./EmojiPicker.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__